import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_PAYMENT_TYPE,
  API_CREATE_PAYMENT_TYPE,
  API_LOAD_PAYMENT_TYPES,
  API_REMOVE_PAYMENT_TYPE,
  API_UPDATE_PAYMENT_TYPE,
  REMOVE_LOCAL_PAYMENT_TYPE,
} from './paymentTypes.reducer';

export const load = () => ({ resourceAction: API_LOAD_PAYMENT_TYPES });
export const save = resource =>
  ((isLocal(resource.id))
    ? { resourceAction: API_CREATE_PAYMENT_TYPE, resource }
    : { resourceAction: API_UPDATE_PAYMENT_TYPE, resource });
export const add = () => ({ type: ADD_LOCAL_PAYMENT_TYPE });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_PAYMENT_TYPE,
  id,
} : { resourceAction: API_REMOVE_PAYMENT_TYPE, id });



// WEBPACK FOOTER //
// ./src/reducers/paymentTypes/paymentTypes.actions.js